import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Loader2, Calculator, ChevronRight, CheckCircle2, AlertCircle } from 'lucide-react';
import { expensasApi } from '../../lib/api';

export default function ExpensasEdificios() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [edificios, setEdificios] = useState([]);

  useEffect(() => {
    (async () => {
      try { const r = await expensasApi.listEdificios(); setEdificios(r.data || []); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="min-h-screen flex justify-center items-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-11 h-11 rounded-xl bg-indigo-100 flex items-center justify-center">
          <Calculator className="w-5 h-5 text-indigo-700" strokeWidth={1.7} />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Expensas</h1>
          <p className="text-slate-500 text-sm">Liquidación mensual de expensas por edificio</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {edificios.map((e) => (
          <button
            key={e.edificio_id}
            onClick={() => navigate(`/expensas/${e.edificio_id}`)}
            className="bg-white border border-slate-200 hover:border-indigo-300 hover:shadow-sm transition rounded-xl p-5 text-left group"
            data-testid={`edificio-card-${e.edificio_id}`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <Building2 className="w-5 h-5 text-slate-600" />
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{e.nombre}</div>
                  <div className="text-xs text-slate-500">{e.direccion || 'Sin dirección'}</div>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 group-hover:translate-x-1 transition-transform" />
            </div>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className={`text-[11px] px-2 py-0.5 rounded-full inline-flex items-center gap-1 ${e.expensas_configurado ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>
                {e.expensas_configurado ? <CheckCircle2 className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
                {e.expensas_configurado ? 'Configurado' : 'Sin configurar'}
              </span>
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
                {e.expensas_cuentas_count || 0} cuentas
              </span>
              <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">
                {e.expensas_periodos_count || 0} períodos
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
